import './App.css';
import { useEffect } from 'react';
import { NavLink, Routes, Route, useLocation } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import Contato from './pages/Contato';
import Projects from './pages/Projects';
import Blog from './pages/Blog';
import Articles from './pages/Articles';
import Article from './pages/Article';
import NotFound from './pages/NotFound';
import Games from './pages/Games';
import Movies from './pages/Movies';
import MoviesAdmin from './pages/MoviesAdmin';
import Swapi from './pages/swapi/Swapi';
import SwapiDetail from './pages/swapi/SwapiDetail';
import RickMorty from './pages/rick-morty/RickMorty';
import RickMortyCharacter from './pages/rick-morty/RickMortyCharacter';
import RickMortyLocation from './pages/rick-morty/RickMortyLocation';
import RickMortyEpisode from './pages/rick-morty/RickMortyEpisode';
import BackToTheFuture from './pages/back-to-the-future/BackToTheFuture';
import { registerGlobalRuntimeErrorHandlers } from './lib/runtimeErrorMonitoring';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    return registerGlobalRuntimeErrorHandlers();
  }, []);

  const getNavLinkClass = ({ isActive }) => {
    return isActive
      ? 'site-shell-link site-shell-link-active px-3 py-2 rounded-md text-sm font-medium transition-colors'
      : 'site-shell-link px-3 py-2 rounded-md text-sm font-medium transition-colors';
  };

  return (
    <ErrorBoundary>
      <div className="min-h-screen flex flex-col site-bg-canvas text-[#2f2a40]">
        <ScrollToTop />

        <header className="site-shell">
          <nav className="container mx-auto px-6 py-3">
            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 md:gap-4">
              <NavLink to="/" className={getNavLinkClass}>
                Home
              </NavLink>
              <NavLink to="/projects" className={getNavLinkClass}>
                Projetos
              </NavLink>
              <NavLink to="/laboratorio" className={getNavLinkClass}>
                Laboratorio
              </NavLink>
              <NavLink to="/blog" className={getNavLinkClass}>
                Blog
              </NavLink>
              <NavLink to="/contato" className={getNavLinkClass}>
                Contato
              </NavLink>
            </div>
          </nav>
        </header>

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/laboratorio" element={<Games />} />
            <Route path="/hub" element={<Games />} />
            <Route path="/jogos" element={<Games />} />
            <Route path="/games" element={<Games />} />
            <Route path="/laboratorio/filmes" element={<Movies />} />
            <Route path="/hub/filmes" element={<Movies />} />
            <Route path="/jogos/filmes" element={<Movies />} />
            <Route path="/games/movies" element={<Movies />} />
            <Route path="/laboratorio/filmes/area-administrativa" element={<MoviesAdmin />} />
            <Route path="/hub/filmes/area-administrativa" element={<MoviesAdmin />} />
            <Route path="/jogos/filmes/area-administrativa" element={<MoviesAdmin />} />
            <Route path="/games/movies/admin" element={<MoviesAdmin />} />
            <Route path="/laboratorio/swapi" element={<Swapi />} />
            <Route path="/hub/swapi" element={<Swapi />} />
            <Route path="/jogos/swapi" element={<Swapi />} />
            <Route path="/games/swapi" element={<Swapi />} />
            <Route path="/laboratorio/swapi/:resource/:id" element={<SwapiDetail />} />
            <Route path="/hub/swapi/:resource/:id" element={<SwapiDetail />} />
            <Route path="/jogos/swapi/:resource/:id" element={<SwapiDetail />} />
            <Route path="/games/swapi/:resource/:id" element={<SwapiDetail />} />
            <Route path="/laboratorio/rick-morty" element={<RickMorty />} />
            <Route path="/hub/rick-morty" element={<RickMorty />} />
            <Route path="/jogos/rick-morty" element={<RickMorty />} />
            <Route path="/games/rick-morty" element={<RickMorty />} />
            <Route path="/laboratorio/rick-morty/personagem/:id" element={<RickMortyCharacter />} />
            <Route path="/hub/rick-morty/personagem/:id" element={<RickMortyCharacter />} />
            <Route path="/jogos/rick-morty/personagem/:id" element={<RickMortyCharacter />} />
            <Route path="/games/rick-morty/personagem/:id" element={<RickMortyCharacter />} />
            <Route path="/laboratorio/rick-morty/local/:id" element={<RickMortyLocation />} />
            <Route path="/hub/rick-morty/local/:id" element={<RickMortyLocation />} />
            <Route path="/jogos/rick-morty/local/:id" element={<RickMortyLocation />} />
            <Route path="/games/rick-morty/local/:id" element={<RickMortyLocation />} />
            <Route path="/laboratorio/rick-morty/episodio/:id" element={<RickMortyEpisode />} />
            <Route path="/hub/rick-morty/episodio/:id" element={<RickMortyEpisode />} />
            <Route path="/jogos/rick-morty/episodio/:id" element={<RickMortyEpisode />} />
            <Route path="/games/rick-morty/episodio/:id" element={<RickMortyEpisode />} />
            <Route path="/laboratorio/back-to-the-future" element={<BackToTheFuture />} />
            <Route path="/hub/back-to-the-future" element={<BackToTheFuture />} />
            <Route path="/jogos/back-to-the-future" element={<BackToTheFuture />} />
            <Route path="/games/back-to-the-future" element={<BackToTheFuture />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/artigos" element={<Articles />} />
            <Route path="/blog/artigos/:slug" element={<Article />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <footer className="site-shell text-[#f6f3fb] text-center py-4 mt-auto">
          <p>&copy; {new Date().getFullYear()} Guilherme Portella. All Rights Reserved.</p>
        </footer>
      </div>
    </ErrorBoundary>
  );
}

export default App;
